import { useMemo } from 'react'

import { t } from '@/i18n'
import {
  CarCarServiceProviderChoices,
  CarCarStatusChoices,
} from '@/apollo/graphql'
import { IOption } from '@/types'
import { colors } from './constants'

export const useSelect = () => {
  const carStatusOptions: IOption<CarCarStatusChoices>[] = useMemo(
    () =>
      Object.entries(CarCarStatusChoices).map(([k, v]) => ({
        label: t(k),
        value: v,
      })),
    [],
  )

  const colorOptions: IOption<string>[] = useMemo(
    () => colors.map(c => ({ label: t(c.label), value: c.value })),
    [],
  )

  const carServiceOptions: IOption<CarCarServiceProviderChoices>[] = useMemo(
    () =>
      Object.entries(CarCarServiceProviderChoices).map(([k, v]) => ({
        label: t(v),
        value: v,
      })),
    [],
  )

  return {
    carStatusOptions,
    colorOptions,
    carServiceOptions,
  }
}
